// extracted by mini-css-extract-plugin
export default {"table":"IPCheckTable_table__0+-Kd","buttonGroup":"IPCheckTable_buttonGroup__anrnN"};